import { render, staticRenderFns } from "./OneOrManySitesField.vue?vue&type=template&id=1ac05b7a&"
import script from "./OneOrManySitesField.vue?vue&type=script&lang=js&"
export * from "./OneOrManySitesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports